/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbRechercheAgrementLocalisationDto } from './FcbRechercheAgrementLocalisationDto';
import {
    FcbRechercheAgrementLocalisationDtoFromJSON,
    FcbRechercheAgrementLocalisationDtoFromJSONTyped,
    FcbRechercheAgrementLocalisationDtoToJSON,
} from './FcbRechercheAgrementLocalisationDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbRechercheAgrementLocalisationDtoPaginatedResults
 */
export interface FcbRechercheAgrementLocalisationDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbRechercheAgrementLocalisationDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbRechercheAgrementLocalisationDto>}
     * @memberof FcbRechercheAgrementLocalisationDtoPaginatedResults
     */
    results?: Array<FcbRechercheAgrementLocalisationDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbRechercheAgrementLocalisationDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbRechercheAgrementLocalisationDtoPaginatedResults interface.
 */
export function instanceOfFcbRechercheAgrementLocalisationDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbRechercheAgrementLocalisationDtoPaginatedResultsFromJSON(json: any): FcbRechercheAgrementLocalisationDtoPaginatedResults {
    return FcbRechercheAgrementLocalisationDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbRechercheAgrementLocalisationDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbRechercheAgrementLocalisationDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbRechercheAgrementLocalisationDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbRechercheAgrementLocalisationDtoPaginatedResultsToJSON(value?: FcbRechercheAgrementLocalisationDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbRechercheAgrementLocalisationDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

